import Dashboard from './dashboard.vue'
export default {
  path: '',
  name: 'dashboard',
  meta: {
    // nav: {
    //   icon: 'dashboard'
    // },
    breadCrumb: 'Dashboard'
  },
  component: Dashboard
}
